import { DictionaryRiverBasinEuDistrictAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useEuRiverBasins() {
  return useAutocompleteSource<DictionaryRiverBasinEuDistrictAutocomplete>({
    url: EvidenceAPI.DICTIONARY_RIVER_BASIN_EU_DISTRICTS + '/autocomplete',
  });
}
